import {
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	styled,
	TableContainer,
	Paper,
} from '@mui/material';
import { abortedPublicationsTableHeader } from '../table-config';
import { TableBodyAborted } from './aborted-table-body.component';

interface IAbortedTableComponent {
	abortedPublications: any[];
}

const StyledTable = styled(Table)({
	thead: {
		tr: {
			th: {
				color: 'white',
				padding: '4px',
				textAlign: 'center',
				border: '1px solid black',
			},
		},
		backgroundColor: '#666666',
	},
	tbody: {
		backgroundColor: '#191919',
		tr: {
			td: {
				padding: '4px',
				textAlign: 'center',
				border: '1px solid black',
			},
		},
	},
});

export const AbortedTableComponent = ({
	abortedPublications,
}: IAbortedTableComponent) => {
	return (
		<TableContainer
			component={Paper}
			sx={{ marign: '8px', whiteSpace: 'nowrap' }}
		>
			<StyledTable>
				<TableHead>
					{abortedPublicationsTableHeader.map((headerRow: any, index: any) => {
						return (
							<TableRow key={`header-${index}`}>
								{headerRow.map((tab: any, index: any) => {
									return (
										<TableCell
											key={`cell-${index}`}
											colSpan={tab.colSpan}
											rowSpan={tab.rowSpan}
											sx={{ backgroundColor: tab.backgroundColor }}
											align="center"
										>
											{tab.title}
										</TableCell>
									);
								})}
							</TableRow>
						);
					})}
				</TableHead>
				<TableBody>
					{abortedPublications.map((publication) => {
						return (
							<TableBodyAborted key={publication.id}>
								{publication}
							</TableBodyAborted>
						);
					})}
				</TableBody>
			</StyledTable>
		</TableContainer>
	);
};
